import React from "react";
import Sortable from 'react-sortablejs';
import FormRuleApiService from '../Apis/FormRuleApi';
import BootstrapModaComponent from '../ReusableComponents/BootstrapComponents/BootstrapModalComponent';

function FormRuleDraggableRecord(props) {
  const showModalForDelete = () => {
    props.onDeleteAction(props.form_rule);
  };
  const form_rule = props.form_rule;
  const index = props.index;
  const form_rule_edit_url = `/dashboard/keenforms/${props.form_rule.keenform_id}/form_rules/${props.form_rule.id}/edit`;
  return (
  <div 
    key={form_rule.id}
    id={form_rule.id}
    data-id={form_rule.id}
    className="form-rule-record">
    <div className="container">
      <div className="row">
        <div className="col-md-4 form-rule-name-col">
          { (index + 1) } - { form_rule.name }
          { form_rule.disable_rule ? <span className="badge badge-danger">rule is disabled</span> : undefined }
        </div>
        <div className="col-md-5 target-attribute-col">
          { 
            form_rule.target_attributes.map((target_attribute, ind) => {
              return (<span key={ind} className="badge badge-secondary">{ target_attribute.name }</span>);
            })
          }
        </div>
        <div className="col-md-3 text-right form-rule-controls">
          <div className="flex-container">
            <div>
              <a
                href={form_rule_edit_url}
                className="btn btn-warning btn-circle">
                <i className="fas fa-edit"> </i>
              </a>
              <button
                type="button"
                onClick={showModalForDelete}
                className="btn btn-danger btn-circle">
                  <i className="fas fa-trash-alt"></i>
              </button>
            </div>
            <div className="drag-handle-container">
              <div 
                className="drag-handle drag-handle-fa-editor drag-handle-background float-right">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>);
}

export default class FormRuleViewComponents extends React.Component{

  constructor(props) {
    super(props);
    this.formRuleApiService = new FormRuleApiService(props.rails_authenticity_token);
    const formRules = props.form_rules;
    this.state = {
      form_rules: formRules,
      show_modal: false,
      selected_form_rule_id: undefined,
    };
  }

  closeModal = () => {
    this.setState({
      show_modal: false,
      selected_form_rule_id: undefined
    });
  }

  deleteFormRule = () => {
    const form_rule = this.state.selected_form_rule;
    this.formRuleApiService.deleteFormRule(form_rule.id, form_rule.keenform_id)
    .then(response => {
      console.log('response after delete: ', response);
      if ( response.success ) {
        this.removeFormRuleFromDisplay(form_rule.id);
      } else {
        console.warn('200 response from deletion but response success isnt true');
        // TODO: show error
        this.setState({
          show_modal: false,
          selected_form_rule_id: undefined
        });
      }
    })
  }

  removeFormRuleFromDisplay = (deleted_form_rule_id) => {
    // find form rule in this.state.form_rule and filter
    const updated_form_rules = this.state.form_rules.filter(form_rule => {
      return form_rule.id != deleted_form_rule_id;
    });
    this.setState({
      form_rules: updated_form_rules,
      show_modal: false,
      selected_form_rule_id: undefined,
    });
  }

  reorderFormRules = (form_rule_id_array) => {
    let updatedFormRules = [];  
    form_rule_id_array.forEach((form_rule_id, index) => {
      const thisFormRule = this.state.form_rules.find( form_rule => form_rule.id.toString() === form_rule_id);
      thisFormRule.position = (index+1);
      updatedFormRules.push(thisFormRule);
    });
    this.setState({
      form_rules: updatedFormRules
    });
    // TODO: send position of each form rule to back end
    this.formRuleApiService.reorderFormRules(this.props.keenform.id, updatedFormRules)
    .then( (response) => {
      return response;
    });
  }

  showModalForConfirmDelete = (form_rule) => {
    this.setState({
      show_modal: true,
      selected_form_rule: form_rule
    });
  }

  render() {
    const selectedFormRule = this.state.selected_form_rule;
    return (
    <div className="form-rule-type-list">
      <h4>
        <span className="font-weight-bold">{ this.props.rule_type.replace("_"," ").toUpperCase() } RULES</span>
       (in order of execution)
      </h4>
      <div className="form-rule-record d-none d-lg-block">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 font-weight-bold">Name</div>
            <div className="col-lg-4 font-weight-bold">Target Attributes</div>
          </div>
        </div>
      </div>
      <Sortable
        options={{
          animation: 150,
          group: {
            name: 'keenformEditor',
            pull: false,
            put: true
          },
          ghostClass: "sortable-ghost",
          handle: ".drag-handle",
        }}
        onChange={(order, sortable) => {
          this.reorderFormRules(order);
        }}
        >
      { 
        this.state.form_rules.map((form_rule, index) => {
          return <FormRuleDraggableRecord
            form_rule={form_rule}
            index={index}
            key={form_rule.id}
            onDeleteAction={this.showModalForConfirmDelete}
          />;
        })
      }
      </Sortable>
      <BootstrapModaComponent
        visible={this.state.show_modal}
        onCloseEvent={this.closeModal}>
        { !!this.state.selected_form_rule ?
          <div>
            <div>Are you sure you want to delete form rule 
              <strong>&nbsp;
                { !!this.state.selected_form_rule ? this.state.selected_form_rule.name : undefined }
              </strong>
            </div>
            <div className="flexbox-container">
              <button 
                className="btn btn-warning btn-lg"
                type="button"
                onClick={this.closeModal}>
                <i className="fas fa-times-circle"></i> Cancel
              </button>
              <button 
                className="btn btn-danger btn-lg"
                type="button" 
                onClick={this.deleteFormRule}>
                <i className="fas fa-trash-alt"></i> Delete Form Rule
              </button>
            </div>
          </div> : <span>no form rule selected</span>
        }
      </BootstrapModaComponent>
    </div>);
  }
}
